










































import Vue from "vue";
import { Alias } from "@tt-app/store/user/types";
import { VUEX_USER_ACTION_NAMES, VUEX_USER_NAMESPACE } from "@tt-app/constants";

import IconSchoolActive from "@joyz/app-core/assets/icons/active/School.svg";
import IconSchoolDefault from "@joyz/app-core/assets/icons/default/School.svg";
import IconSwap from "@joyz/app-core/assets/icons/default/Swap.svg";

interface Data {
  icons: {
    [name: string]:
      | {
          active: string;
          default: string;
        }
      | string;
  };
  selectedAliasIndex: number;
}

interface Methods {}

interface Computed {
  aliases: Alias[];
}

interface Props {
  opened: boolean;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "AliasChangeModal",

  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const aliases = this.$store.state.user.aliases;
    const selectedAlias = this.$store.state.user.selectedAlias;

    const selectedAliasIndex = aliases.findIndex((alias: Alias) => {
      return alias.uuid === selectedAlias.uuid;
    });

    return {
      icons: {
        school: {
          active: IconSchoolActive,
          default: IconSchoolDefault
        },
        swap: IconSwap
      },
      selectedAliasIndex
    };
  },

  computed: {
    aliases() {
      return this.$store.state.user.aliases;
    }
  },

  methods: {
    handleAliasChange() {
      const alias = this.aliases[this.selectedAliasIndex];

      this.$store.dispatch(`${VUEX_USER_NAMESPACE}/${VUEX_USER_ACTION_NAMES.SELECT_ALIAS}`, {
        alias
      });

      this.$emit("close");
    },

    handleAliasClick(index: number) {
      this.selectedAliasIndex = index;
    }
  }
});
